<script>
import { slide } from 'svelte/transition';
import { onMount } from 'svelte';

// Props for the component
export let item = '';         // The item text to display
export let loading = false;   // Whether to show loading state
export let index = 0;         // Index for staggered animation

// Reference to content element
let contentElem;
</script>

<div class="thread-item-wrapper relative flex flex-align-center" data-testid="thread-item-wrapper" style="--delay: {index * 50}ms;">
    {#if loading}
        <div class="thread-loading flex gap-2 flex-center relative w-full" data-testid="thread-loading" in:slide={{ delay: index * 50, duration: 150 }} bind:this={contentElem}>
            <div class="loading-dot rounded-full"></div>
            <div class="loading-dot rounded-full"></div>
            <div class="loading-dot rounded-full"></div>
        </div>
    {:else}
        <div class="thread-item" data-testid="child-term-{item.replace(/\s+/g, '-').toLowerCase()}" in:slide={{ delay: index * 50, duration: 150 }} bind:this={contentElem}>
            {item}
        </div>
    {/if}
</div>

<style>
/* Thread item styles */
.thread-item-wrapper {
    margin-bottom: var(--spacing-2);
    margin-left: 0;
}

.thread-item {
    position: relative;
    width: fit-content;
    padding: var(--spacing-2) var(--spacing-3);
    font-size: calc(var(--font-size-sm) * 0.93);
    font-weight: var(--font-weight-medium);
    color: var(--child-term-color, var(--color-terms-800));
    background-color: var(--child-term-bg, var(--color-term-bg));
    border: 1px solid var(--child-term-border, var(--color-term-border));
    border-radius: var(--border-radius-xl);
    opacity: 0;
    box-shadow: var(--shadow-xs);
    transition: all var(--duration-normal) var(--ease-in-out);
    transform: translateY(5px);
    animation: fadeIn var(--duration-normal) var(--ease-out) forwards;
    animation-delay: var(--delay, 0ms);
}

.thread-item:hover {
    background-color: var(--child-term-bg-hover, var(--color-terms-thread-hover));
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
}

.thread-loading {
    padding: var(--spacing-3);
    background-color: var(--color-term-bg-loading);
    border: 1px solid var(--color-term-border-loading);
    border-radius: var(--border-radius-xl);
    box-shadow: var(--shadow-xs);
    animation: fadeIn var(--duration-normal) var(--ease-out) forwards;
}

.loading-dot {
    width: 9px;
    height: 9px;
    background-color: var(--color-terms-500);
    opacity: 0.7;
    animation: dot-pulse 1.4s infinite ease-in-out;
}

.loading-dot:nth-child(2) {
    animation-delay: 0.2s;
}

.loading-dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes dot-pulse {
    0%, 100% { opacity: 0.5; transform: scale(0.7); }
    50% { opacity: 0.9; transform: scale(1); }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
        transform: translateY(5px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>